e4.login = {
    debug: false,
    init: function () {
        // ATTENTION: Please note that all events are triggered on jQuery( document ) and not the login form.
        e4.login.event = e4.util.registerEvents( 'userauthenticated', 'login' );
        e4.login.checkUserAuthentication();
        e4.login.bindEvents();
    },
    bindEvents: function () {
        jQuery( '.js-e-login-remember' ).on( 'change', function ( event ) {
            e4.login.toggleRememberUser( event.target );
        } ).triggerHandler( 'change' );
    },
    checkUserAuthentication: function () {
        var loggedOnCookie = e4.login.getCrossSubdomainCookie( 'my.id.loggedOn' );
        if ( loggedOnCookie === 'true' ) {
            jQuery( document ).trigger( e4.login.event.userauthenticated );
            sessionStorage.setItem( 'e4.login.isUserAuthenticated', 'true' );
        }
        else {
            // Invalidate info if user logs off.
            sessionStorage.setItem( 'e4.login.isUserAuthenticated', 'false' );
        }
    },
    getCrossSubdomainCookie: function ( key ) {
        var result;
        return ( result = new RegExp( '(?:^|; )' + encodeURIComponent( key ) + '=([^;]*)' ).exec( document.cookie ) ) ? ( result[ 1 ] ) : null;
    },
    toggleRememberUser: function ( domInput ) {
        jQuery( domInput.form ).find( '.js-e-login-remember-username, .js-e-login-remember-password' ).val( ( jQuery( domInput ).prop( 'checked' ) === true ? 'True' : '' ) );
    }
};
